import classnames from 'classnames/bind'
import React from 'react'

import ImageWithPlaceholder, {
  ImageWithPlaceholderProps,
} from '~/components/ImageWithPlaceholder'
import Ratio from '~/components/Ratio'
import RichText, { RichTextBlock } from '~/components/RichText'

import { useStyle } from '~/providers/StyleProvider'

import css from './styles.module.scss'

const cx = classnames.bind(css)

const RATIO = 341 / 314

export interface AlternateTextImageProps {
  className?: string
  title?: RichTextBlock[]
  text?: RichTextBlock[]
  image?: ImageWithPlaceholderProps
  inversed?: boolean
}

function AlternateTextImage({
  className,
  title,
  text,
  image,
  inversed,
}: AlternateTextImageProps) {
  const titleStyle = useStyle({ textPreset: 'title-section', color: 'ebony' })
  const textStyle = useStyle({
    textPreset: 'text-paragraph',
    color: 'cornflower-blue',
  })

  return (
    <div className={cx(css.AlternateTextImage, className, { inversed })}>
      <div className={css.content}>
        {image && (
          <Ratio ratio={RATIO} className={css.imageWrapper}>
            {(cn) => (
              <ImageWithPlaceholder
                layout="fill"
                objectFit="contain"
                {...image}
              />
            )}
          </Ratio>
        )}
        <div className={css.contentWrapper}>
          {title && (
            <RichText className={cx(titleStyle, css.title)} render={title} />
          )}
          {text && (
            <RichText className={cx(textStyle, css.text)} render={text} />
          )}
        </div>
      </div>
    </div>
  )
}

AlternateTextImage.defaultProps = {
  inversed: false,
}

export default AlternateTextImage
